import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedWorkspaceV2App from "./EmbeddedWorkspaceV2App";
const ExternalLink = ({ href, title }) => /* @__PURE__ */ React.createElement("a", { href, rel: "noopener noreferrer", target: "_blank" }, title);
const WorkspaceV2App = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Google Workspace" }, /* @__PURE__ */ React.createElement("span", null, "This input retrieves log records from ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/bigquery", title: "BigQuery" }), " ", "using the", " ", /* @__PURE__ */ React.createElement(
  ExternalLink,
  {
    href: "https://support.google.com/a/topic/9079469",
    title: "Google Workspace logs and reports in BigQuery"
  }
), " ", "export capability.")), /* @__PURE__ */ React.createElement(EmbeddedWorkspaceV2App, null));
export default WorkspaceV2App;
